import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from '../services/http/http.service';
import { HeaderType } from "@dealpos-npm/ng-dealpos-library/header-type";

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  Email : string;
  Password: string;
  inputType: string;
  alert: any;
  showHideClass: string;
  constructor(private httpService: HttpService, private toastr: ToastrService, private elementRef: ElementRef) {
    // set title TAB Web Browser
    document.title = "Outlet | Forgot Password Form";
    this.inputType = "password";
    this.showHideClass = "fas fa-eye fas";
    this.alert = {
      Visible: false,
      Message: null,
      Success: false
    }
  }

  ngOnInit(): void {
    //change background color to light blue
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#dfeffc';
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'white';
  }

  Submit() {
    if (!this.alert.Success) {
      const data = {
        Email: this.Email
      };
      this.forgotPassword(data);
    }
    else {
      const data = {
        Email: this.Email,
        Password: this.Password
      };
      this.resetPassword(data)
    }
  }
  forgotPassword(data: {Email: string}) {
    this.httpService.post<any>("/API/Authentication/ForgotPassword", JSON.stringify(data))
    .subscribe({
      next: (res) => {
        this.alert.Visible = true;
        this.alert.Success = true;
        this.alert.Message = res.Message;
      },
      error: (err) => {
        this.alert.Visible = true;
        this.alert.Success = false;
        this.alert.Message = err.error.Message ? err.error.Message : err.error;
      }
    });
  }
  resetPassword(data: {Email: string, Password: string}) {
    this.httpService.post<any>("/API/Authentication/SubmitNewPassword", JSON.stringify(data))
    .subscribe({
      next: (res) => {
        this.alert.Visible = false;
        this.alert.Success = false;
        this.toastr.success(res.Message, HeaderType.Success);
      }
    });
  }

  public showPassword() {
    this.showHideClass =
      this.showHideClass == "fas fa-eye fas"
        ? "fas fas fa-eye-slash"
        : "fas fa-eye fas";
    this.inputType =
      this.showHideClass == "fas fa-eye fas" ? "password" : "text";
  }
}